/* @flow */
import API from 'lib/RemindAPI';
import { cloneDeep } from 'lodash';
import Entity from 'lib/Entity';
import Reactions from 'collections/Reactions';

export default class ReactionSummary extends Entity {
  defaults() {
    return {
      version: 0,
      reactions: new Reactions(),
    };
  }

  parse(response: Object) {
    const reactionSummary = cloneDeep(response);

    reactionSummary['reactions'] = Reactions.fromJSON(reactionSummary['reactions']);

    return reactionSummary;
  }

  getReactions(): Reactions {
    return this.get('reactions');
  }

  getVersion(): number {
    return this.get('version');
  }

  getMessageUuid(): ?string {
    return this.get('message_uuid');
  }

  /* Reactions in a Chat context */

  static createReaction(name: string, chatUuid: string, messageUuid: string): Promise<ReactionSummary> {
    return API.request(
      `/chats/${chatUuid}/messages/${messageUuid}/reactions`,
      'POST',
      {
        add: [name],
        remove: [],
      }
    ).then(reactionSummary => ReactionSummary.fromJSON(reactionSummary));
  }

  static deleteReaction(name: string, chatUuid: string, messageUuid: string): Promise<ReactionSummary> {
    return API.request(
      `/chats/${chatUuid}/messages/${messageUuid}/reactions`,
      'POST',
      {
        add: [],
        remove: [name],
      }
    ).then(reactionSummary => ReactionSummary.fromJSON(reactionSummary));
  }
}



// WEBPACK FOOTER //
// ./src/entities/ReactionSummary.js